import React from 'react'
import { FaTrash } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/delete.less'

type DeleteControlProps = {
  deleteActive: () => void
  isCreating: boolean
  isEditing: boolean
  disabled: boolean
  control: string
}

const DeleteControl = ({ deleteActive, isCreating, isEditing, disabled, control }: DeleteControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing || disabled) {
      return
    }
    deleteActive()
  }

  return (
    <div className={cn('control', 'delete')} data-graph-type="control" title={`Delete ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing || disabled })} onClick={handleClick}>
        <FaTrash aria-hidden />
        <span className="sr-only">Delete</span>
      </a>
    </div>
  )
}

export default DeleteControl
